/** @file bookings/driver.js — my-bookings / my-driver-jobs views. */
import { supabase } from "@/lib/supabaseClient";

export async function listMyBookings({ userId, companyId = null, limit = 100 } = {}) {
  return supabase
    .from("lbs_bookings")
    .select(
      `id, reference_number, status, direction, scheduled_start, scheduled_end,
       site_id, bay_id, sender_name, receiver_name, vehicle_type,
       site:lbs_sites!lbs_bookings_site_id_fkey(name,code),
       bay:lbs_bays!lbs_bookings_bay_id_fkey(name,code)`
    )
    .or(companyId ? `created_by_user_id.eq.${userId},approved_booker_id.eq.${companyId}` : `created_by_user_id.eq.${userId}`)
    .order("scheduled_start", { ascending: false })
    .limit(limit);
}

export async function listMyDriverJobs({ userId }) {
  void userId; // RLS narrows to the current driver
  const now = new Date();
  const dayAfterTomorrow = new Date(now);
  dayAfterTomorrow.setDate(now.getDate() + 2);
  return supabase
    .from("lbs_bookings")
    .select(
      `id, reference_number, status, direction, scheduled_start, scheduled_end,
       site_id, bay_id, sender_name, receiver_name, vehicle_type, driver_phone,
       arrival_time, checkin_time, checkout_time,
       site:lbs_sites!lbs_bookings_site_id_fkey(name,code,city,address_line1,state,timezone),
       client:lbs_clients!lbs_bookings_client_id_fkey(name,brand_logo_url),
       bay:lbs_bays!lbs_bookings_bay_id_fkey(name,code)`
    )
    .gte("scheduled_start", now.toISOString())
    .lt("scheduled_start", dayAfterTomorrow.toISOString())
    .order("scheduled_start", { ascending: true });
}
